import React, { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import Genders from "../../components/genders/Genders";
import axios from "axios";
import { Loaders } from "../Loaders";

const GendersPage = () => {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getGenderData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/gender?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setLoader(false)
    } catch (error) { setLoader(false) }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/gender?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }

  useEffect(() => {
    getGenderData(1);
  }, []);
  const onChangeVal = (e) => {
    // console.log(e);
    getGenderData(e)

  };
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title="Genders" />
        <h3 className="page-title">
          Manage Genders
        </h3>
        <Genders data={data} getGenderData={getGenderData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
};

export default GendersPage;
